<script>
/**
 * 受注編集モーダル
 */
import orderForm from '../../orders/accepts/collection/_Form.vue'
export default {
  name: "EditOrderModal",
  components: {
    orderForm
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: Number,
      default: null,
    },
    orderType: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      key: 0,
      buttonLocked: false,
    }
  },
  computed: {

  },
  watch: {
    enableDialog(value) {
      if (value) {
        this.key++
      }
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    /**
     * 受注登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.orderForm.registerOrderButtonClickEvent();
    },
    /**
     * 受注登録 コールバック
     */
    registerCallback () {
      this.$emit('registerCallback');
    },
    /**
     * ボタン制御
     * @param value
     */
    loadingCallback (value) {
      this.buttonLocked = value
    },
    orderTypeName () {
      if (this.orderType === 'collection') {
        return "産廃"
      } else if (this.orderType === 'general') {
        return "一廃"
      }
    },
  },
}
</script>

<template>
  <v-dialog
    :value="enableDialog"
    fullscreen
    persistent
    scrollable
    transition="dialog-bottom-transition"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <v-card flat rounded="false">
      <v-card-title
        class="primary white--text"
      >
        受注編集（{{ orderTypeName() }}）
        <v-spacer />
        <v-btn
          icon
          dark
          @click="closeButtonClickEvent"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-container>
          <order-form
            ref="orderForm"
            :key="key"
            :edit-order-id="orderId"
            :callable-type="orderType"
            load-by="driver_schedule"
            @registerCallback="registerCallback"
            @loadingCallback="loadingCallback"
          />
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          :disabled="buttonLocked"
          class="mr-15"
          color="primary"
          @click="registerButtonClickEvent"
        >
          受注登録
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">

</style>
